import { useEffect } from 'react'
import { flushCheckpoints } from './checkpoints'
import { createIdlePolicy, IDLE_DELAY } from './idlePolicy'

export function CheckpointLifecycle() {
  useEffect(() => {
    const idle = createIdlePolicy(Date.now, () => { void flushCheckpoints('idle') })
    let timer: ReturnType<typeof setTimeout>
    const check = () => {
      clearTimeout(timer)
      const remaining = idle.check()
      if (remaining > 0) timer = setTimeout(check, remaining)
    }
    const touch = () => {
      idle.check()
      idle.touch()
      clearTimeout(timer)
      timer = setTimeout(check, IDLE_DELAY)
    }
    const leave = () => { void flushCheckpoints('pagehide') }
    const visibility = () => { if (document.visibilityState === 'visible') check() }
    const events = ['pointerdown', 'pointermove', 'keydown', 'input', 'wheel', 'touchstart'] as const
    events.forEach(event => window.addEventListener(event, touch, { passive: true }))
    document.addEventListener('visibilitychange', visibility)
    window.addEventListener('pagehide', leave)
    window.addEventListener('pageshow', check)
    timer = setTimeout(check, IDLE_DELAY)
    return () => {
      clearTimeout(timer)
      events.forEach(event => window.removeEventListener(event, touch))
      document.removeEventListener('visibilitychange', visibility)
      window.removeEventListener('pagehide', leave)
      window.removeEventListener('pageshow', check)
    }
  }, [])
  return null
}
